export default "__VITE_ASSET__foV1qgtO__"